import { render, staticRenderFns } from "./StaticRegisterDropdown.vue?vue&type=template&id=0d34018d&"
import script from "./StaticRegisterDropdown.vue?vue&type=script&lang=js&"
export * from "./StaticRegisterDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports